import styles from "./expenseCategoryFilter.module.css";
import { Plus, Search } from "react-feather";
import { Link } from "react-router-dom";

const ExpenseCategoryFilter = ({ setFilterData, setAddModalOpen }) => {
  return (
    <div className={`${styles.SearchFilterSec}`}>
      <div className={`${styles.SearchCon}`}>
        <div className={`${styles.SearchConSec}`}>
          <Search />
          <input
            type="text"
            placeholder="Search"
            onChange={(e) =>
              setFilterData((prev) => {
                return { ...prev, searchKey: e.target.value };
              })
            }
          />
        </div>
      </div>
      <div className={`${styles.FilterSec}`}>
        {/* <div
          className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Status"
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, type: e.target.value };
                });
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Prospect">Prospect</MenuItem>
              <MenuItem value="Tenant">Tenant</MenuItem>
              <MenuItem value="Contact">Contact</MenuItem>
            </Select>
          </FormControl>
        </div> */}
        <Link
          className={`${styles.AddNoteBu}`}
          onClick={(e) => setAddModalOpen(true)}
        >
          <Plus /> <span>Category</span>
        </Link>
      </div>
    </div>
  );
};

export default ExpenseCategoryFilter;
